import { WrapperCenter } from 'components/atoms/SectionWrapper.style';
import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  weight: 300px;
  height: 100px;
  background-color: transparent;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 25px;
  margin: 30px 0;
  border: 2px solid green;
  a {
    text-decoration: none;
    text-align: center;
    color: black;
    &:hover {
      text-decoration: underline;
    }
    &:visited {
      color: black;
    }
  }
`;
const Center = styled.div`
  display: flex;
`;

const ElePortofilio = () => (
  <>
    <Center>
      <WrapperCenter>
        <Button>
          <a
            href="https://drive.google.com/file/d/1pGQnVA1n0Ha6DNSwERTw0pMvuutciXyq/view?usp=sharing"
            target="_blank"
          >
            pobierz portofolio <br /> elgreen elektromobility
          </a>
        </Button>
      </WrapperCenter>
    </Center>
  </>
);

export default ElePortofilio;
